import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { BACKEND_URL } from "../../../../helpers/variables";
import { Autocomplete, TextField } from "@mui/material";
import { useLoaderData } from "react-router-dom";

export const Property = () => {
  const { client_url, corporation_id, dev_mode = false } = useLoaderData();
  const { values, setFieldValue, handleBlur, touched, errors } =
    useFormikContext();

  const [corporationList, setCorporationList] = useState([]);

  useEffect(() => {
    async function fetchCorporationList() {
      let url = `${BACKEND_URL}/corporation_list?client_url=${client_url}`;
      let res = await fetch(url);
      let data = await res.json();

      let property = data.find((i) => i["corporationID"] === corporation_id);
      setFieldValue("property", property);

      setCorporationList(data);
    }

    fetchCorporationList();
  }, []);

  return (
    <Autocomplete
      value={values["property"]}
      readOnly={!dev_mode}
      size="small"
      options={corporationList}
      getOptionLabel={(option) => option.Name}
      onChange={(_, v) => setFieldValue("property", v)}
      onBlur={handleBlur}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Properties"
          required
          error={touched.property && Boolean(errors.property)}
          helperText={touched.property && errors.property}
        />
      )}
      {...(!dev_mode && { popupIcon: "" })}
    />
  );
};
